
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { isRecoverableChunkLoadError, recoverFromChunkLoadError } from './utils/runtimeRecovery';

// Service Worker Registration
// We disable SW in preview environments (StackBlitz, Google Cloud Shell/IDX, AI Studio) because they often 
// serve the app and assets from different origins, causing SecurityErrors.
const isPreviewEnv = 
  window.location.host.includes('stackblitz') || 
  window.location.host.includes('usercontent.goog') || 
  window.location.host.includes('ai.studio') ||
  window.location.host.includes('googleusercontent.com');

if ('serviceWorker' in navigator && !isPreviewEnv) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);

        registration.update().catch((error) => {
          console.warn('ServiceWorker update check failed', error);
        });

        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              installingWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      },
      (err) => {
        // Suppress expected errors in some environments
        console.log('ServiceWorker registration failed (This is normal in development previews): ', err);
      }
    );

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  });
}

window.addEventListener('unhandledrejection', (event) => {
  if (isRecoverableChunkLoadError(event.reason)) {
    recoverFromChunkLoadError().catch((error) => {
      console.warn('Unhandled rejection recovery failed', error);
    });
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
